export default "__VITE_ASSET__QOggYB1___"